import { Component, OnInit, inject } from '@angular/core';
import { ContractFormComponent } from "../contract-form/contract-form.component";
import { ContractService } from '../services/contract.service';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-contract-create',
  standalone: true,
  imports: [ContractFormComponent],
  templateUrl: './contract-create.component.html',
  styleUrl: './contract-create.component.css'
})
export class ContractCreateComponent implements OnInit {
  service = inject(ContractService)
  access = inject(AccessService).access

  ngOnInit(): void {
    this.service.title.update(value => 'Nuevo Contrato')
  }
}
